<script setup>
import { analytics, segmentLoaded } from '@/modules/segment'
import { SUPPORTED_LOCALES, loadLocaleMessages, setI18nLanguage } from '@/i18n'

const props = defineProps({ widget: { type: String, required: true } })

const i18n = inject('i18n')

async function updateLocale(e) {
  const locale = e.target.value

  if (!i18n.global.availableLocales.includes(locale)) {
    await loadLocaleMessages(i18n, locale, props.widget)

    if (segmentLoaded.value)
      analytics.track('Language Changed', { language: locale })
  }

  // set i18n language
  setI18nLanguage(i18n, locale)
}

const localeLookup = {
  en: 'English',
  es: 'Español',
}
</script>

<template>
  <div class="cd-language-select">
    <select @change="updateLocale">
      <option
        v-for="(locale, index) in SUPPORTED_LOCALES"
        :key="index"
        :value="locale"
        :selected="i18n.global.locale.value === locale"
      >
        {{ localeLookup[locale] }}
      </option>
    </select>
  </div>
</template>
